export default __webpack_public_path__ + "static/media/030_corner1.av1.30f920b0.mp4";